import React from 'react';

import * as Colors from '../../constants/Colors';
import { BaseSvgIcon } from '../BaseSvgIcon';
import { SvgIconProps } from '../IconProps';

export type CircleTickIconProps = SvgIconProps & {
    color?: string;
};

export const CircleTickIcon = ({ color = Colors.green, ...props }: CircleTickIconProps) => (
    <BaseSvgIcon viewBox="0 0 24 24" fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z"
            fill={color}
        />
        <path d="M9 13L11 15L15 9" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </BaseSvgIcon>
);

CircleTickIcon.defaultProps = {
    alt: 'Tick circle icon',
    width: '28px',
    height: '28px',
    color: Colors.green,
};
